import getField from '@form/formGenerator'

export const mairieMissionSaveUrl = `${import.meta.env.VITE_API_URL}/api/missions/save`

const mairieMissionFormFields = (
  step,
  missionMairieFormObject,
  errors,
  updateFormObject,
  updateFormObjectProp,
  saveForm,
  isLoading,
  t,
  creationModalCaller,
  data
) => {
  let fields = []

  fields['mairie'] = [{
    type: 'select',
    name: 'mairie',
    label: t('form.mission_mairie'),
    value: typeof missionMairieFormObject.mairie === 'object' ? missionMairieFormObject.mairie.id : missionMairieFormObject.mairie,
    key: 'missionMairieFormObject-mairie',
    cssClass: 'mission-mairie column is-6',
    withIcon: false,
    help: t('help.mission_mairie_help'),
    canCreate: true,
    creationModalCaller: () => creationModalCaller('mairie', 'mairies'),
    options: data.mairies,
    disabled: false,
    error: [],
    isRequired: true
  }, {
    type: 'text',
    name: 'addressComplement',
    label: t('form.address_complement'),
    value: missionMairieFormObject.addressComplement,
    key: 'missionMairieFormObject-addressComplement',
    cssClass: 'column is-6',
    isRequired: true,
    help: t('form.address_complement_help'),
  }, {
    type: 'text',
    name: 'coordinates',
    label: t('form.coordinates'),
    value: 'object' === typeof missionMairieFormObject.coordinates ? JSON.stringify(missionMairieFormObject.coordinates) : missionMairieFormObject.coordinates,
    key: 'missionMairieFormObject-coordinates',
    cssClass: 'column is-6',
    isRequired: true,
    help: t('form.coordinates_help'),
  }]

  fields['responsible'] = [{
    type: 'text',
    name: 'responsibleFullName',
    label: t('form.responsible_full_name'),
    value: missionMairieFormObject.responsibleFullName,
    key: 'missionMairieFormObject-responsibleFullName',
    cssClass: 'column is-12',
    isRequired: true
  },
  {
    type: 'text',
    name: 'responsiblePhone',
    label: t('form.responsible_phone'),
    value: missionMairieFormObject.responsiblePhone,
    key: 'missionMairieFormObject-responsiblePhone',
    cssClass: 'column is-12',
    isRequired: true
  },
  {
    type: 'text',
    name: 'responsibleEmail',
    label: t('form.responsible_email'),
    value: missionMairieFormObject.responsibleEmail,
    key: 'missionMairieFormObject-responsibleEmail',
    cssClass: 'column is-12',
    isRequired: true
  }, {
    type: 'select',
    name: 'city',
    label: t('form.mission_city'),
    value: typeof missionMairieFormObject.city === 'object' ? missionMairieFormObject.city.id : missionMairieFormObject.city,
    key: 'missionMairieFormObject-city',
    cssClass: 'mission-city column is-6',
    withIcon: false,
    help: t('help.mission_city_help'),
    canCreate: true,
    creationModalCaller: () => creationModalCaller('city', 'cities'),
    options: data.cities,
    disabled: false,
    error: [],
    isRequired: true
  },
  {
    type: 'number',
    name: 'zipCode',
    label: t('form.zip_code'),
    value: missionMairieFormObject.zipCode,
    key: 'missionMairieFormObject-zipCode',
    cssClass: 'column is-6',
    isRequired: true
  }, {
    type: 'checkbox',
    name: 'missionSubjects',
    label: t('form.mission_subjects'),
    key: 'missionMairieFormObject-missionSubjects',
    cssClass: 'column is-12',
    options: data.missionSubjects,
    canCreate: true,
    creationModalCaller: () => creationModalCaller('missionSubject', 'missionSubjects'),
    isMultiple: true,
    value: missionMairieFormObject.missionSubjects,
    isRequired: true
  }]

  fields['firstScan'] = [
    {
      type: 'date',
      name: 'firstScanStartsAt',
      value: missionMairieFormObject.firstScanStartsAt,
      label: t('form.from'),
      key: 'missionMairieFormObject-firstScanStartsAt',
      cssClass: 'mission-starts-at column is-6',
      isInline: true,
      isRequired: true
    }, {
      type: 'date',
      name: 'firstScanEndsAt',
      value: missionMairieFormObject.firstScanEndsAt,
      label: t('form.to'),
      key: 'missionMairieFormObject-firstScanEndsAt',
      cssClass: 'mission-ends-at column is-6',
      isInline: true,
      isRequired: true
    },
    {
      type: 'checkbox',
      name: 'firstScanPilots',
      label: t('form.which_pilot'),
      key: 'missionMairieFormObject-firstScanPilots',
      cssClass: 'column is-12',
      options: data.pilots,
      canCreate: true,
      creationModalCaller: () => creationModalCaller('userRegister', 'pilots'),
      isMultiple: true,
      value: missionMairieFormObject.firstScanPilots,
      isRequired: true
    }]

  fields['secondScan'] = [{
    type: 'date',
    name: 'secondScanStartsAt',
    value: missionMairieFormObject.secondScanStartsAt,
    label: t('form.from'),
    key: 'missionMairieFormObject-secondScanStartsAt',
    cssClass: 'mission-starts-at column is-6',
    isInline: true,
    isRequired: true
  }, {
    type: 'date',
    name: 'secondScanEndsAt',
    value: missionMairieFormObject.secondScanEndsAt,
    label: t('form.to'),
    key: 'missionMairieFormObject-secondScanEndsAt',
    cssClass: 'mission-ends-at column is-6',
    isInline: true,
    isRequired: true
  },
  {
    type: 'checkbox',
    name: 'secondScanPilots',
    label: t('form.which_pilot'),
    key: 'missionMairieFormObject-secondScanPilots',
    cssClass: 'column is-12',
    options: data.pilots,
    canCreate: true,
    creationModalCaller: () => creationModalCaller('userRegister', 'pilots'),
    isMultiple: true,
    value: missionMairieFormObject.secondScanPilots,
    isRequired: true
  }]

  fields['mission'] = [{
    type: 'text',
    name: 'missionTitle',
    label: t('form.mission_title'),
    value: missionMairieFormObject.missionTitle,
    key: 'missionMairieFormObject-missionTitle',
    cssClass: 'column is-12',
    isRequired: true
  }, {
    type: 'tinymce',
    config: 'min',
    name: 'externalLink',
    label: t('form.external_link'),
    help: t('form.external_link_help'),
    height: 200,
    disabled: false,
    initialValue: missionMairieFormObject.externalLink,
    key: 'missionMairieFormObject-externalLink',
    cssClass: 'column is-12'
  }, {
    type: 'tinymce',
    config: 'min',
    name: "missionDescription",
    cssClass: 'column is-12 mission-description',
    disabled: false,
    label: t('form.mission_description'),
    initialValue: missionMairieFormObject.missionDescription,
    isRequired: true
  }, {
    type: 'file',
    name: 'missionLogo',
    blobPoster: missionMairieFormObject.missionLogo ?? false,
    cssClass: 'column is-6 mission-logo',
    simpleInput: false,
    key: 'missionMairieFormObject-missionLogo',
    disabled: false,
    label: t('form.mission_logo'),
    targetUrl: `${import.meta.env.VITE_API_URL}/api/push/temp-files`,
    isRequired: true
  }]

  fields['missionOptions'] = [{
    type: 'text',
    name: 'missionUrl',
    label: t('form.mission_url'),
    help: t('form.mission_url_help'),
    value: missionMairieFormObject.missionUrl,
    key: 'missionMairieFormObject-missionUrl',
    cssClass: 'column is-12',
    isRequired: true
  }, {
    type: 'textarea',
    name: 'specialStyle',
    label: t('form.special_style'),
    value: missionMairieFormObject.specialStyle,
    key: 'missionMairieFormObject-specialStyle',
    cssClass: 'column is-12'
  }, {
    type: 'switcher',
    name: 'isCompany',
    label: t('form.mission_company'),
    value: missionMairieFormObject.isCompany,
    cssClass: 'column is-6',
    key: 'missionMairieFormObject-isCompany'
  },
  {
    type: 'switcher',
    name: 'isCompanyBilled',
    label: t('form.mission_company_billed'),
    value: missionMairieFormObject.isCompanyBilled,
    cssClass: `column is-6 ${!missionMairieFormObject.isCompany ? 'is-hidden' : ''}`,
    key: 'missionMairieFormObject-isCompanyBilled',
  },
  {
    type: 'switcher',
    name: 'isCoOwnership',
    label: t('form.mission_co_ownership'),
    value: missionMairieFormObject.isCoOwnership,
    cssClass: 'column is-6',
    key: 'missionMairieFormObject-isCoOwnership'
  }, {
    type: 'switcher',
    name: 'isCoOwnershipBilled',
    label: t('form.mission_co_ownership_billed'),
    value: missionMairieFormObject.isCoOwnershipBilled,
    cssClass: `column is-6 ${!missionMairieFormObject.isCoOwnership ? 'is-hidden' : ''}`,
    key: 'missionMairieFormObject-isCoOwnershipBilled',
  }, {
    type: 'radio',
    name: 'billingType',
    label: t('form.billing_type'),
    key: 'missionMairieFormObject-billingType',
    cssClass: 'column is-12',
    options: data.billingTypes,
    canCreate: true,
    creationModalCaller: () => creationModalCaller('billingType', 'billingTypes'),
    isMultiple: true,
    value: missionMairieFormObject.billingType,
    isRequired: false
  },
  {
    type: 'switcher',
    name: 'isActive',
    label: t('form.mission_is_active'),
    value: missionMairieFormObject.isActive,
    cssClass: 'column is-12',
    key: 'missionMairieFormObject-isActive',
    id: 'missionMairieFormObject-isActive',
  },
  {
    type: 'switcher',
    name: 'isMultipleCities',
    label: t('form.mission_is_multiple_cities'),
    value: missionMairieFormObject.isMultipleCities,
    cssClass: 'column is-12',
    key: 'missionMairieFormObject-isMultipleCities',
    id: 'missionMairieFormObject-isMultipleCities',
  }]

  fields['submit'] = [{
    type: 'button',
    buttons: true,
    callback: saveForm,
    cancel: false,
    validateText: t('form.save'),
    cssClassParent: 'column is-12',
    cssClassValidate: 'button is-blue',
    validateIcon: 'icon-done',
    key: 'missionMairieFormObject-form',
    isLoading
  },
  {
    type: 'hidden',
    name: 'id',
    value: parseInt(missionMairieFormObject.id),
    key: 'missionMairieFormObject-id'
  }]

  return fields[step].map(function (field) {
    return getField({ ...field, error: errors[field.name] ? errors[field.name].errors : '' }, updateFormObject, updateFormObjectProp)
  })
}

export const missionFormObject = {
  mairie: '',
  responsibleFullName: '',
  responsibleEmail: '',
  responsiblePhoneNumber: '',
  missionResponsibleFullName: '',
  missionResponsibleEmail: '',
  missionResponsiblePhoneNumber: '',
  companyName: '',
  companyTvaNumber: '',
  missionAddress: '',
  city: '',
  district: '',
  zipCode: '',
  firstScanStartsAt: '',
  firstScanEndsAt: '',
  firstScanPilots: '',
  secondScanStartsAt: '',
  secondScanEndsAt: '',
  secondScanPilots: '',
  id: '',
  firstScanpilots: '',
  secondScanpilots: '',
  logo: '',
  missionTitle: '',
  missionDescription: '',
  isCompanyBilled: false,
  companyBillingPriceM2: '',
  isCoOwnership: false,
  isCompany: false,
  isActive: false,
  isMultipleCities: false,
  coordinates: '',
  addressComplement: '',
  externalLink: '',
  billingType: ''
}

export default mairieMissionFormFields